export enum PopupsActionType {
  ShowChangePurchasedSubscription = 'popups/SHOW_CHANGE_PURCHASED_SUBSCRIPTION',
  HideChangePurchasedSubscription = 'popups/HIDE_CHANGE_PURCHASED_SUBSCRIPTION',
  ShowRegionSelectPopup = 'popups/SHOW_REGION_SELECT',
  HideRegionSelectPopup = 'popups/HIDE_REGION_SELECT',
}
